import { ICON_TYPES } from '../constants';
import { IconPropsType } from '../IconProps.type';

export const BusinessCenterIcon = (props: IconPropsType): JSX.Element => {
  const svgProps = {
    fill: props.fill || '#43494F',
    width: props.width || '21',
    height: props.height || '18',
  };
  return (
    <svg viewBox="0 0 21 18" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <path
        d="M21 14.625V3.25C21 2.55381 20.7234 1.88613 20.2312 1.39384C19.7389 0.901562 19.0712 0.625 18.375 0.625H2.625C1.92881 0.625 1.26113 0.901562 0.768845 1.39384C0.276562 1.88613 0 2.55381 0 3.25L0 14.625H9.625V15.5H6.125V17.25H14.875V15.5H11.375V14.625H21ZM1.75 3.25C1.75 3.01794 1.84219 2.79538 2.00628 2.63128C2.17038 2.46719 2.39294 2.375 2.625 2.375H18.375C18.6071 2.375 18.8296 2.46719 18.9937 2.63128C19.1578 2.79538 19.25 3.01794 19.25 3.25V12.875H1.75V3.25Z"
        fill={svgProps.fill}
      />
    </svg>
  );
};
BusinessCenterIcon.iconType = ICON_TYPES.BUSINESS_CENTER_ICON;
